import { render, staticRenderFns } from "./OrganisationUsersList.vue?vue&type=template&id=095b0a2a&"
import script from "./OrganisationUsersList.vue?vue&type=script&lang=js&"
export * from "./OrganisationUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports